// extracted by mini-css-extract-plugin
export default {"project_menu":"Project_menu_project_menu__2M7MA","nav_Link":"Project_menu_nav_Link__5JqPF"};